import { render, staticRenderFns } from "./RequiredDot.vue?vue&type=template&id=c5e23bac&"
import script from "./RequiredDot.vue?vue&type=script&lang=js&"
export * from "./RequiredDot.vue?vue&type=script&lang=js&"
import style0 from "./RequiredDot.vue?vue&type=style&index=0&id=c5e23bac&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/test-tripanels/clusterpanels/hwy-client-panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c5e23bac')) {
      api.createRecord('c5e23bac', component.options)
    } else {
      api.reload('c5e23bac', component.options)
    }
    module.hot.accept("./RequiredDot.vue?vue&type=template&id=c5e23bac&", function () {
      api.rerender('c5e23bac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/RequiredDot.vue"
export default component.exports